import React from "react";

export default function Label({ label }) {
    return <label>{label}</label>;
}
